import { Alert } from '@material-ui/lab'
import { Grid, Typography } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import { useVEventoStyles } from "./styles"
import HomePage from "../../Home"
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import TGruposCalendario from "./TablaGrupos"
import { useEffect } from 'react'
import { obtenerFecha, obtenerEventosAction, clearCalendarioState } from '../../../ducks/viajeCalendarioDuck'
import BackDrop from '../../../global/BackDrop'
import { useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import ButtonReturn from '../../../global/ButtonReturn'
const VEventos = () => {
  const dispatch = useDispatch()
  const { state } = useLocation()
  const Params = useParams()
  const [load, setLoad] = useState(false)
  const grupos = useSelector((store) => store.calendario.eventos)
  console.log("🚀 ~ VEventos ~ grupos:", grupos)
  const { fecha } = useSelector((store) => store.calendario)
  const classes = useVEventoStyles()
  useEffect(() => {
    dispatch(obtenerFecha())
    return () => {
      dispatch(clearCalendarioState())
    }
  }, [dispatch])

  useEffect(() => {
    setLoad(true)
    dispatch(obtenerEventosAction({ fecha: Params?.fecha, fechaSelect: state?.fechaCorta })).then(Response => {
      setLoad(false)
    })
  }, [dispatch, Params?.fecha, state?.fechaCorta])

  return (
    <HomePage>
      <Grid container>
        <Grid item xs={12} className={classes.containerHead}>
          <div className={classes.title}>
            <Typography component="h5" variant="h5">
              <SupervisorAccountIcon /> Viajes
            </Typography>
          </div>
          <div>
            <ButtonReturn />
          </div>
        </Grid>
        <Grid item xs={12} className={classes.containerHead}>
          <div>
            <Typography component="h7" variant="h7">
              {`Salida ${fecha}`}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.root}>
            {
              (grupos?.lSalida?.length <= 0 && grupos?.lLiquidacion?.length <= 0 && grupos?.lAereo?.length <= 0) &&
              <div>
                <Alert severity="info">No hay datos pora mostrar</Alert>
              </div>

            }
            {
              (grupos?.lSalida?.length > 0) &&
              <div>
                <br />
                <h1>Salidas</h1>
                <TGruposCalendario rows={grupos?.lSalida} />
                <br />
              </div>
            }
            {
              (grupos?.lAereo?.length > 0) &&
              <div>
                <br />
                <h1>Aereos</h1>
                <TGruposCalendario rows={grupos?.lAereo} />
                <br />
              </div>
            }
            {
              (grupos?.lLiquidacion?.length > 0) &&
              <div>
                <br />
                <h1>Liquidaciones</h1>
                <TGruposCalendario rows={grupos?.lLiquidacion} />
                <br />
              </div>
            }
          </div>
        </Grid>
      </Grid>
      <BackDrop open={load} />
    </HomePage>

  );
};
export default VEventos;
